import { render, staticRenderFns } from "./Rl2.vue?vue&type=template&id=0e533c2f&"
import script from "./Rl2.vue?vue&type=script&lang=js&"
export * from "./Rl2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports